export default __webpack_public_path__ + "static/media/(25).24ee3209.jpg";